<template>
  <FormLabel :required="required" :text="text" :error="forceError || error">
    <input class="aoformfield" :placeholder="placeholder" type="email" ref="input" :readonly="$store.getters.loading" :name="name" @blur="filledCheck" @keydown.down.stop.prevent="$refs.droplist.focus()" v-model="val">
  </FormLabel>
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import FormField from '@/mixins/FormField.vue'
import blur from '@/mixins/blur'

export default {
  components: { FormLabel },
  mixins: [FormField, blur],
  props: {
    forceError: { type: String, default: '' },
    required: { type: Boolean, default: false },
    name: { type: String, required: true },
    modelValue: { type: String, default: '' },
    text: { type: String, required: true },
    placeholder: { type: String },
    validation: { type: Function, default: () => '' },
    filled: { type: Function, default: (v) => v ? true : false },
  },
  data: () => ({
    error: ''
  }),
  methods: {
    isValidEmail(email) {
      return email.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    },
    filledCheck() {
      if (this.modelValue == '') return this.error = ""
      if (!this.filled(this.modelValue)) {
        this.error = "Заполните поле"
      }
    }
  },
  computed: {
    val: {
      get() { return this.modelValue },
      set(value) { this.$emit('update:modelValue', value) },
    },
  },
  watch: {
    modelValue(newVal) {
      if (!this.isValidEmail(newVal))
        this.error = 'Некорректный email'
      else
        this.error = this.validation(newVal)
      /*
      if (newVal && !this.error)
        this.$store.dispatch('callAction', this.name)*/
    }
  }
}
</script>

<style lang="sass">

</style>